// extracted by mini-css-extract-plugin
module.exports = {"reactSwitchCheckbox":"Switch_reactSwitchCheckbox__3sVes","reactSwitchLabel":"Switch_reactSwitchLabel__1stOX","reactSwitchButton":"Switch_reactSwitchButton__2rwFV"};